module.exports = __webpack_public_path__ + "static/media/defaultSubject.8780dcf6.svg";